export function getInfo(job) {
    let dateText = " ";
    let date = " ";
    let popup = "No info available";

    if (job.overallStatus === "ENQUIRY RECEIVED") {
        dateText = "Enquiry received: ";
        date = job.dates.enquiryReceived.slice(8, 10) + "/" + job.dates.enquiryReceived.slice(5, 7) + "/" + job.dates.enquiryReceived.slice(0, 4);
        popup = "New";
    } else if (job.overallStatus === "ENQUIRY APPROVED") {
        dateText = "Enquiry approved: ";
        date = job.dates.enquiryApproved;
        popup = "Enquiry Approved";
    } else if (job.overallStatus === "NO DESIGNS") {
        dateText = "Designs requested: ";
        date = job.dates.designsRequested;
        popup = "Designs requested";
    } else if (job.overallStatus === "DESIGNS UPLOADED") {
        dateText = "Designs uploaded: ";
        date = job.dates.designsUploaded;
        popup = "Designs uploaded";
    } else if (job.overallStatus === "DESIGN CHOSEN") {
        dateText = "Design chosen: ";
        date = job.dates.designChosen;
        popup = "Design chosen";
    } else if (job.overallStatus === "PAYMENT MADE") {
        dateText = "Payment made: ";
        date = job.dates.designsCompleted;
        popup = "Payment made";
    } else if (job.overallStatus === "VINYLS PRINTED") {
        dateText = "Vinyls printed: ";
        date = job.dates.printFilesCompleted;
        popup = "Vinyls printed";
    } else if (job.overallStatus === "INSTALLATION SCHEDULED") {
        dateText = "Installation scheduled: ";
        date = job.dates.installationScheduled;
        popup = "Installation scheduled";
    } else if (job.overallStatus === "INSTALLATION COMPLETED") {
        dateText = "Installation completed: ";
        date = job.dates.installationComplete;
        popup = "Installation completed";
    } else if (job.overallStatus === "COMPLETE") {
        dateText = "Completed: ";
        date = job.dates.installationComplete;
        popup = "Job Completed";
    }
    return [dateText, date, popup];
}